import { getPatientAgeToDisplay } from '@silbo/core';
import { t } from 'i18next';

export const formatAge = (date: Date) => {
  const { unit, value } = getPatientAgeToDisplay(date);

  if (unit === 'day') {
    return t(`age.${value > 1 ? 'days' : 'day'}`, { count: value });
  }

  if (unit === 'month') {
    return t('age.month', { count: value });
  }

  return t(`age.${value > 1 ? 'years' : 'year'}`, { count: value });
};
